import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { bytesToMegabytes } from '@/utils/common'
// eslint-disable-next-line
import ComponentChatxMessage from './chatx-message/chatx-message'
import ChatxModule from './chatx.module'

@Component({
  ...ChatxModule,
})
export default class ComponentChatx extends Vue {
  @Prop({ default: true }) showRecipientImage: boolean
  @Prop({ default: '' }) recipientImage: string
  @Prop({ default: '' }) recipientName: string
  @Prop({ default: '' }) recipientLastSeenDate: string
  @Prop({ default: false }) recipientOnline: boolean

  @Prop({ default: false }) showLeftPanel: boolean
  @Prop({ default: false }) showRightPanel: boolean
  @Prop({ default: false }) readOnly: boolean
  @Prop({ default: true }) canSendAttachment: boolean
  @Prop({ default: false }) attachmentLoading: boolean

  inputText = ''
  isFileTypeWarningModalOpen = false
  isUploadRecommendationModalOpen = false
  fileUploadLimitInMegaBytes = 25

  @Prop({ default: null }) lastComponentMessage: ComponentChatxMessage

  mounted() {
    // Listen lastComponentMessage to scroll to end
    this.$watch('lastComponentMessage', (newValue, oldValue) => {
      this.scrollToEnd()
    })
  }

  @Emit()
  send() {
    // Clear the content editable
    const contentEditableElement = this.$refs.contentEditable as HTMLElement
    contentEditableElement.innerHTML = ''

    const value = this.inputText
    this.inputText = ''

    return value
  }

  chooseAttachment() {
    const input = document.createElement('input')

    input.type = 'file'
    input.accept = 'application/pdf, image/*'

    input.onchange = (event: any) => {
      const file = event.target.files[0] as File
      const fileType: string = file.type

      if (fileType !== 'application/pdf' && !fileType.match(/(^image)(\/)[a-zA-Z0-9_]*/gm)) {
        this.openFileTypeWarningModal(500)
        return
      }

      if (bytesToMegabytes(file.size) > this.fileUploadLimitInMegaBytes) {
        this.openUploadRecommendationModal(500)
        return
      }

      this.$emit('sendAttachment', file)
    }

    input.click()
  }

  openFileTypeWarningModal(delay = 0) {
    setTimeout(() => {
      this.isFileTypeWarningModalOpen = true
    }, delay)
  }

  closeFileTypeWarningModal() {
    this.isFileTypeWarningModalOpen = false
  }

  openUploadRecommendationModal(delay = 0) {
    setTimeout(() => {
      this.isUploadRecommendationModalOpen = true
    }, delay)
  }

  closeUploadRecommendationModal() {
    this.isUploadRecommendationModalOpen = false
  }

  listenContentEditableKeyEvents(e: Event) {
    e.preventDefault()
    if (this.inputText) {
      this.send()
    }
  }

  scrollToEnd() {
    const contentScrollElement = this.$refs.contentScroll as HTMLElement
    setTimeout(() => {
      contentScrollElement.scrollTo(0, contentScrollElement.scrollHeight)
    }, 0)
  }

  formatLastSeenDate(dateString: string) {
    if (dateString) {
      const date = new Date(dateString)
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')

      let completedDate: string
      if (date.toLocaleDateString() === new Date().toLocaleDateString()) {
        completedDate = 'Hoje'
      } else {
        completedDate = date.toLocaleDateString()
      }

      return `${completedDate} às ${hours}:${minutes}`
    }

    return ''
  }

  // Permissions

  get canSendMessage() {
    return this.inputText
  }

  get canEnableSendButton() {
    return this.canSendMessage
  }

  get canShowLastSeen() {
    return !this.recipientOnline && this.recipientLastSeenDate
  }

  get canShowOnline() {
    return this.recipientOnline
  }

  get canEdit() {
    return !this.readOnly
  }
}
